import React, { Component } from 'react';

import classes from './DataUploader.module.css';
import Input from '../../UI/Input/Input';
import Button from '../../UI/Buttons/Button';
import axios from '../../axiosdata';
import { updateObject, checkValidation } from '../../shared/utility';
import { connect } from 'react-redux';


class DataUploader extends Component {
    
    state = {
        programForm: {
            programName: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'Ohjelman nimi'
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 0
                },
                valid: false,
                touched: false
            },
            groupName: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'Ryhmän nimi'
                },
                value: '',
                validation: {
                    required: false,
                    minLength: 0
                },
                valid: true,
                touched: false
            },
            date: {
                elementType: 'input',
                elementConfig: {
                    type: 'date',
                    placeholder: 'Päivämäärä'
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 0
                },
                valid: false,
                touched: false
            },
            startTime: {
                elementType: 'input',
                elementConfig: {
                    type: 'time',
                    placeholder: 'Ohjelma alkaa'
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 2
                },
                valid: false,
                touched: false
            },
            end_time: {
                elementType: 'input',
                elementConfig: {
                    type: 'time',
                    placeholder: 'Ohjelma loppuu'
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 2
                },
                valid: false,
                touched: false
            },
            info: {
                elementType: 'textarea',
                elementConfig: {
                    type: 'text',
                    placeholder: 'Lisätietoa ohjelmasta (valinnainen)'
                },
                value: '',
                validation: {
                    required: false,
                    minLength: 0
                },
                valid: true,
                touched: false
            },
        },
        formIsValid: false,
        missingInfo: false,
        saveError: null
    }

    inputChangedHandler = (event, inputIdentifier) => {
            const updatedFormElement = updateObject(this.state.programForm[inputIdentifier], {
            value: event.target.value,
            valid: checkValidation(event.target.value, this.state.programForm[inputIdentifier].validation),
            touched: true
        });
        
        const updatedBooksForm = updateObject(this.state.programForm, {
            [inputIdentifier]: updatedFormElement
        });
        
        let formIsValid = true;
        for (let inputIdentifier in updatedBooksForm) {
            formIsValid = updatedBooksForm[inputIdentifier].valid && formIsValid;
        }
        this.setState({programForm: updatedBooksForm, formIsValid: formIsValid});
        
    }


    saveInformationToFireBase = (event) =>{
        event.preventDefault();
        if(this.state.formIsValid){
            this.SaveBookToFireBase();
        } else {
            this.setState({missingInfo: true})
        }

    }

    SaveBookToFireBase = () => {
        const formData = {
            program: {}
        };
        for (let formElementIdentifier in this.state.programForm) {
            formData.program[formElementIdentifier] = this.state.programForm[formElementIdentifier].value;
        }

        axios.post('/programs.json', formData)
        .then(() => this.props.onSuccess())
        .catch(err => {
            const msg = err.response ? `${err.response.status}: ${JSON.stringify(err.response.data)}` : err.message;
            this.setState({ saveError: msg });
        });
    } 

    render () {
        const formElementsArray = [];
        let missingInfoWarning = '';
        if (this.state.missingInfo){
            missingInfoWarning = <div className={classes.warning}>Anna kaikki tarvittavat tiedot!</div>;
        }
        let saveError = '';
        if (this.state.saveError){
            saveError = <div className={classes.warning}>Tallennus epäonnistui: {this.state.saveError}</div>;
        }
            
        for (let key in this.state.programForm) {
            formElementsArray.push({
                id: key,
                config: this.state.programForm[key]
            });
        }
        let form = (
            <div>   
                <form>
                {formElementsArray.map(formElement =>(
                    <div key={formElement.id}>

                    <Input
                        elementType={formElement.config.elementType}
                        elementConfig={formElement.config.elementConfig}
                        value={formElement.config.value}
                        invalid={!formElement.config.valid}
                        shouldValidate={formElement.config.validation}
                        touched={formElement.config.touched}
                        label={formElement.config.elementConfig.placeholder}
                        changed={(event) => this.inputChangedHandler(event, formElement.id)}/>
                        </div>
                ))}
                {missingInfoWarning}
                </form>
                {saveError}
                    <Button click={this.saveInformationToFireBase}>Tallenna</Button>
                    <Button click={this.props.cancel}>Peruuta</Button>  

            </div>
        );

        return (
                <div className={classes.programData}>
                    <div className={classes.Title}>
                        <h2>Lisää ohjelma</h2>
                    </div>
                        {form}
                </div>
        );
    }
}

const mapStateToProps = state => {
    return {
    }
}

export default connect(mapStateToProps)(DataUploader);
